import { styled, Chip } from '@mui/material'

export const Counter = styled(Chip, { name: 'Counter' })({
  fontWeight: 'bold',
  paddingTop: 2,
})
